import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;
// const API_BASE_URL = 'http://localhost:8070/jmk001/api';
const token = sessionStorage.getItem('token');

const apiClientMonthly = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`, },
});

apiClientMonthly.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export const studentsApi = {
  getAll: (params) => apiClientMonthly.get(`/classroom/academic/school/${params}`),
}
// Tests APIs
export const testsApi = {
  getAll: (params) => apiClientMonthly.get('/monthly-tests', { params }),
  getById: (id) => apiClientMonthly.get(`${'/monthly-tests'}/${id}`),
  create: (data) => apiClientMonthly.post('/monthly-tests', data),
  update: (id, data) => apiClientMonthly.put(`${'/monthly-tests'}/${id}`, data),
  delete: (id) => apiClientMonthly.delete(`${'/monthly-tests'}/${id}`),
  publish: (id) => apiClientMonthly.put(`${'/monthly-tests'}/${id}/publish`),
};

// Marks APIs
export const marksApi = {
  getMarks: (testId) => apiClientMonthly.get(`${'/monthly-tests'}/${testId}/marks`),
  saveMarks: (testId, data) => apiClientMonthly.post(`${'/monthly-tests'}/${testId}/marks/bulk`, data),
  updateMarks: (testId, marksId, data) => apiClientMonthly.put(`${'/monthly-tests'}/${testId}/marks/${marksId}`, data),
};

// Files APIs
export const filesApi = {
  getFiles: (testId) => apiClientMonthly.get(`${'/monthly-tests'}/${testId}/files`),
  uploadFile: (testId, formData) => apiClientMonthly.post(`${'/monthly-tests'}/${testId}/files`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  deleteFile: (testId, fileId) => apiClientMonthly.delete(`${'/monthly-tests'}/${testId}/files/${fileId}`),
};

export default apiClientMonthly;